import { render, staticRenderFns } from "./RoleInformation.vue?vue&type=template&id=05e50392&scoped=true&"
import script from "./RoleInformation.vue?vue&type=script&lang=js&"
export * from "./RoleInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e50392",
  null
  
)

export default component.exports